//EXTERNAL
import React from "react"
//COMPONENTS
import BouncingIcon from "../BouncingIcon"
//ASSETS
import demoArticleHero from "../../assets/demo-article-hero.jpg"
import "./Article.css"
//FUNCTIONS

export default function ArticleMobile(format) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "flex-column",
        justifyContent: "center",
        minWidth: "320px"
      }}>
      <div
        style={{
          backgroundColor: "white",
          overflowX: "hidden",
          overflowY: "scroll"
        }}>
        <img src={demoArticleHero} style={{ width: "100%" }} alt="article-header" />
        <div className="serif" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <h2 className="f5 b">Stories are about to surpass feed sharing. Now what?</h2>
          <h4 className="f7 navy i mt1">Stories are growing 15X faster than feeds, so behaviours must evolve</h4>
          <hr />
          <BouncingIcon />
          <div className="tj lh-copy athelas">
            <p>
              We’re at the cusp of the visual communication era. Stories creation and consumption is up 842 percent since early 2016, according to consulting firm Block Party. Nearly a billion accounts across Snapchat, Instagram, WhatsApp, Facebook, and Messenger now create and watch these vertical, ephemeral slideshows. And yesterday, Facebook chief product officer Chris Cox showed a chart detailing how “the Stories format is on a path to surpass feeds as the primary way people share things
              with their friends sometime next year.”
            </p>
            <p>The repercussions of this medium shift are vast. Users now consider how every moment could be glorified and added to the narrative of their day. Social media platforms are steamrolling their old designs to highlight the camera and people’s Stories. And advertisers must rethink their message not as a headline, body text, and link, but as a background, overlays, and a feeling that lingers even if viewers don’t click through.</p>
            <div className="flex flex-row justify-center">{format}</div>
            <p>
              WhatsApp’s Stories now have over 450 million daily users. Instagram’s have over 300 million. Facebook Messenger’s had 70 million in September. And Snapchat as a whole just reached 191 million, about 150 million of which use Stories according to Block Party. With 970 million accounts, it’s the format of the future. Block Party calculates that Stories grew 15X faster than feeds from Q2. Users now consider how every moment could be glorified and added to the narrative of their day.
              Social media platforms are steamrolling their old designs to highlight the camera and people’s Stories.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
